// TextInputLimitado.js
import React from "react";
import { TextField } from "@material-ui/core";
import { useFormContext } from "react-hook-form";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";

const TextInputLimitado = () => {
  const classesTablero = useStylesTablero();
  const { register, setValue, errors } = useFormContext();

  const handleInput = (event) => {
    const value = event.target.value.toUpperCase(); // Convertir a mayúsculas
    setValue("nombreCarpeta", value); // Actualizar el valor en el formulario
  };

  const requerido = {
    required: "Este campo es requerido", // Validación para campo requerido
    maxLength: {
      value: 100,
      message: "Máximo 100 caracteres permitidos", // Mensaje de error si excede el máximo
    },
    validate: (value) => {
      // Validación para espacios, solo mayúsculas y números, sin caracteres especiales
      if (!/^[A-Z0-9\s]+$/.test(value)) {
        return "Solo se permiten letras mayúsculas y números sin caracteres especiales";
      }
      if (/^\s|\s$/.test(value)) {
        return "No se permiten espacios al inicio o al final";
      }
      return true; // Si pasa todas las validaciones, retorna true
    },
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <TextField
        inputRef={register(requerido)}
        label="Nombre de Carpeta"
        variant="outlined"
        name="nombreCarpeta"
        error={!!errors?.nombreCarpeta} // Manejo del error
        helperText={errors?.nombreCarpeta?.message || ""} // Mensaje de error
        onInput={handleInput} // Manejar el input
        className={classesTablero.field}
      />
    </div>
  );
};

export default TextInputLimitado;
